import { validateString } from 'avilatek-utils';
import { EmployeeInfo } from '../../models';

export function validateEmployeeInfoForm({
  role,
  relationship,
  salesChannel,
  region,
  subRegion,
}: Partial<EmployeeInfo>): string {
  if (!validateString(role) || String(role).length > 127) {
    return 'Cargo inválido';
  }

  if (!validateString(relationship) || String(relationship).length > 127) {
    return 'Relación del beneficiario inválida';
  }

  if (!validateString(salesChannel) || String(salesChannel).length > 127) {
    return 'Canal de ventas inválido';
  }

  if (!validateString(region) || String(region).length > 127) {
    return 'Región inválida';
  }

  if (!validateString(subRegion) || String(subRegion).length > 127) {
    return 'Sub-región inválida';
  }

  return '';
}
